import PropTypes from 'prop-types'
import React from 'react'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { Separator } from '../../../common/separator'
import { HighlightItem } from './HighLightItem'
import classes from './index.module.scss'

export const HighlightInfo = ({ highlights, isLoading, containerStyle }) => {
  return (
    <Element
      className={classes.container}
      style={{ borderBottomColor: '#e5e5e8', ...containerStyle }}
    >
      {isLoading && <Loading />}
      <Element
        className={classes.highlightList}
        style={{ opacity: isLoading ? 0 : 1 }}
      >
        {highlights.map((item, index) => (
          <React.Fragment key={index}>
            <HighlightItem item={item} />
            {item.isShowSeparator && (
              <Separator width={1} backgroundColor="#9C9C9C" />
            )}
          </React.Fragment>
        ))}
      </Element>
    </Element>
  )
}

HighlightInfo.propTypes = {
  isLoading: PropTypes.bool,
  highlights: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      detail: PropTypes.any,
      isShowSeparator: PropTypes.bool,
      isI18n: PropTypes.bool,
      formatDetail: PropTypes.func,
    }),
  ),
  containerStyle: PropTypes.object,
}

HighlightInfo.defaultProps = {
  isLoading: false,
  highlights: [],
  containerStyle: {},
}
